import { type TFunction } from '@wix/ricos/dist/src/ricos-types';

import { type Currency } from '../../types';

import { localizeNumberInput } from './numeric-input-utils';

export const formatPrice = (input: string, locale?: string) => {
  const filteredInput = input.replace(',', '.').match(/[\d.]+/);
  if (!filteredInput) {
    return null;
  }

  const number = filteredInput[0];
  const decimalSeparator = number.indexOf('.');

  const decimal =
    decimalSeparator !== -1 && number.length > decimalSeparator + 2
      ? number.substring(0, decimalSeparator + 3)
      : number;

  const localizedNumber = localizeNumberInput(decimal, locale);
  const normalizedValue = Number(localizedNumber.replace(/,/g, '.'));

  return isNaN(normalizedValue) ? null : localizedNumber;
};

export const getCurrencyAriaLabel = (t: TFunction, currency?: Currency) =>
  currency?.code
    ? t(`locale-dataset.currencies.${currency?.code}`)
    : currency?.sign || '';
